import { EditServiceRequest } from "./EditServiceRequest"
import { FC } from "react"
import { NewServiceRequest } from "./NewServiceRequest"
import { ServiceRequestStatus } from "../models"
import { useServiceRequestContext } from "./ServiceRequestContext"

interface IServiceRequestProps {
    className?: string
    isEditable?: boolean
    editOnly?: boolean
    submitLabel?: string
    entity?: string
    relativePath?: string
    hideHeader?: boolean
    hideTitle?: boolean
    changeStatus?: boolean
    enableResend?: boolean
    enableSubmit?: boolean
    documentsOnly?: boolean
    enableApproval?: boolean
    isSendingForApproval?: boolean
    tooltip?: string
    onComplete: (requestId: string) => void,
    onCancel: (requestId: string) => void
}

export const ServiceRequestInner: FC<IServiceRequestProps> = ({
    className,
    tooltip,
    isEditable,
    editOnly,
    submitLabel,
    entity,
    relativePath,
    hideHeader,
    hideTitle,
    changeStatus,
    enableResend,
    enableSubmit,
    documentsOnly,
    enableApproval,
    isSendingForApproval,
    onComplete,
    onCancel
}) => {
    const { result } = useServiceRequestContext()
    const { serviceRequest, service, metadata } = result || {};

    if (enableApproval && serviceRequest?.statusCode === ServiceRequestStatus.Draft) {
        return <div className="text-center fs-6 fw-semibold my-3">
            Request #<span className="fw-bold">{serviceRequest.requestNumber}</span> is not yet submitted.
        </div>
    }

    return <>
        <div className={className} title={tooltip}>
            {(!serviceRequest && service && !isEditable && !editOnly) && <>
                <NewServiceRequest
                    submitLabel={submitLabel}
                    entity={entity}
                    relativePath={relativePath}
                    hideHeader={hideHeader === true}
                    hideTitle={hideTitle}
                    metadata={metadata}
                    changeStatus={changeStatus}
                    onComplete={onComplete} />
            </>}
            {(serviceRequest) && <>
                <EditServiceRequest
                    entity={entity}
                    submitLabel={submitLabel}
                    enableResend={enableResend!}
                    enableSubmit={enableSubmit}
                    enableApproval={enableApproval}
                    relativePath={relativePath}
                    documentsOnly={documentsOnly === true}
                    hideHeader={hideHeader === true}
                    hideTitle={hideTitle}
                    metadata={metadata}
                    isSendingForApproval={isSendingForApproval}
                    changeStatus={changeStatus}
                    onComplete={onComplete}
                    onCancel={onCancel} />
            </>}
        </div>
    </>
}
